/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CashflowForecastIndicatorDistributionEntry'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CashflowForecastIndicatorDistributionEntry'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CashflowForecastIndicatorConnectionReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CashflowForecastIndicatorDistributionEntry);
  }
}(this, function(ApiClient, CashflowForecastIndicatorDistributionEntry) {
  'use strict';




  /**
   * The CashflowForecastIndicatorConnectionReport model module.
   * @module model/CashflowForecastIndicatorConnectionReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>CashflowForecastIndicatorConnectionReport</code>.
   * @alias module:model/CashflowForecastIndicatorConnectionReport
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>CashflowForecastIndicatorConnectionReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CashflowForecastIndicatorConnectionReport} obj Optional instance to populate.
   * @return {module:model/CashflowForecastIndicatorConnectionReport} The populated <code>CashflowForecastIndicatorConnectionReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Distribution')) {
        obj['Distribution'] = ApiClient.convertToType(data['Distribution'], [CashflowForecastIndicatorDistributionEntry]);
      }
      if (data.hasOwnProperty('ProfitSourceIndicatorID')) {
        obj['ProfitSourceIndicatorID'] = ApiClient.convertToType(data['ProfitSourceIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('BalanceTargetIndicatorID')) {
        obj['BalanceTargetIndicatorID'] = ApiClient.convertToType(data['BalanceTargetIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('VAT')) {
        obj['VAT'] = ApiClient.convertToType(data['VAT'], 'Number');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/CashflowForecastIndicatorDistributionEntry>} Distribution
   */
  exports.prototype['Distribution'] = undefined;
  /**
   * @member {Integer} ProfitSourceIndicatorID
   * @default 0
   */
  exports.prototype['ProfitSourceIndicatorID'] = 0;
  /**
   * @member {Integer} BalanceTargetIndicatorID
   * @default 0
   */
  exports.prototype['BalanceTargetIndicatorID'] = 0;
  /**
   * @member {Number} VAT
   * @default 0.0
   */
  exports.prototype['VAT'] = 0.0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


